import { HTMLAttributes } from 'react'

import Media from '@/components/base/media'
import Typography from '@/components/base/typography'
import { sanitizeAdsLink } from '@/utils/path'

import { cn } from '@/lib/utils'
import { WPImage } from '@/types'

type HeroProps = HTMLAttributes<HTMLDivElement> &
  Partial<{
    image: WPImage
    title: string
    paragraph: string
    link: {
      url: string
      title: string
      target: string
    }
  }>

const Hero = ({ image, title, paragraph, link, className }: HeroProps) => {
  return (
    <div className={cn(className)}>
      <div
        className={cn(
          'relative z-10 aspect-[16/9] w-full overflow-hidden md:aspect-[16/4.5]'
        )}
      >
        <Media
          fill
          fit="cover"
          use_video={false}
          image={image}
          data-motion-media
        />
        <div className="absolute inset-0 flex flex-col items-center justify-center gap-[2rem] bg-black/15 p-[3rem]">
          {title ? (
            <Typography
              component="h1"
              className="text-[3.6rem] font-light leading-[1] text-white md:text-[7.2rem]"
            >
              {title}
            </Typography>
          ) : null}
          {paragraph ? (
            <Typography component="p" className="text-white/80">
              {paragraph}
            </Typography>
          ) : null}
          {link?.url ? (
            <a
              href={sanitizeAdsLink(link.url)}
              target={link.target}
              className={cn('button', className)}
            >
              <Typography component="p">{link.title}</Typography>
            </a>
          ) : null}
        </div>
      </div>
    </div>
  )
}

export default Hero
